export { default as PaymentSuccess } from './PaymentSuccess';
export { default as PaymentFailure } from './PaymentFailure';
